import styled from "styled-components";

export const ThoughtsPage = styled.div`
  min-height: calc(100vh - 160px);
`;

export const ThoughtsPaper = styled.main`
  position: relative;
  max-width: 960px;
  margin: 0 auto;
  padding: 64px 24px 96px;
  display: grid;
  grid-template-columns: 260px minmax(0, 1fr);
  gap: 72px;
  font-family: "Literata", Georgia, serif;
  @media (max-width: 768px) {
    display: block;
    max-width: 320px;
    padding: 48px 0px 88px;
  }
`;

export const ThoughtsAside = styled.aside`
  position: sticky;
  top: 104px;
  align-self: start;
  @media (max-width: 768px) {
    position: static;
    margin-bottom: 52px;
  }
`;

export const ThoughtsTitle = styled.h1`
  margin: 8px 0px 16px;
  color: var(--heading);
  font-size: 30px;
  line-height: 38px;
  font-weight: normal;
`;

export const ThoughtsNote = styled.p`
  margin: 24px 0px 0px;
  color: var(--muted);
  font-family: "Aktiv Grotesk Corp", "DM Sans", sans-serif;
  font-size: 12px;
  line-height: 18px;
`;

export const ThoughtsRefresh = styled.button`
  margin: 0px;
  padding: 0px;
  border: 0px;
  color: inherit;
  background: transparent;
  font: inherit;
  text-decoration: underline;
  text-underline-offset: 3px;
  cursor: pointer;
`;

export const ThoughtsIntroduction = styled.p`
  margin: 0px;
  color: var(--text);
  font-size: 16px;
  line-height: 26px;
  font-style: italic;
`;

export const ThoughtList = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 38px;
  &:before {
    content: "";
    position: absolute;
    inset: -24px -24px;
    pointer-events: none;
    opacity: 0.08;
    background:
      repeating-linear-gradient(
        0deg,
        transparent 0px,
        transparent 31px,
        #9c957f 32px
      ),
      radial-gradient(circle at 12% 18%, #d9c99f, transparent 16%),
      radial-gradient(circle at 86% 72%, #d9c99f, transparent 13%);
    transform: rotate(-0.2deg);
  }
  @media (max-width: 768px) {
    &:before {
      inset: 18px -12px;
    }
  }
`;

export const ThoughtLink = styled.a`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 28px;
  align-items: start;
  color: var(--text);
  text-decoration: none;
  &:hover span:last-child {
    transform: translate(6px, -3px);
  }
  @media (max-width: 768px) {
    gap: 16px;
  }
`;

export const ThoughtSource = styled.span`
  display: block;
  margin-bottom: 5px;
  color: var(--muted);
  font-family: "Aktiv Grotesk Corp", "DM Sans", sans-serif;
  font-size: 11px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
`;

export const ThoughtTitle = styled.h2`
  margin: 0px 0px 5px;
  color: var(--heading);
  font-size: 20px;
  line-height: 27px;
  font-weight: normal;
  @media (max-width: 768px) {
    font-size: 20px;
    line-height: 27px;
  }
`;

export const ThoughtDescription = styled.p`
  max-width: 620px;
  margin: 0px;
  color: var(--subtle);
  font-size: 14px;
  line-height: 22px;
  @media (max-width: 768px) {
    font-size: 14px;
    line-height: 22px;
  }
`;

export const ThoughtArrow = styled.span`
  margin-top: 22px;
  font-size: 18px;
  transition: transform 0.2s ease;
`;

export const ThoughtsLoading = styled.p`
  position: relative;
  color: var(--muted);
  font-family: "Aktiv Grotesk Corp", "DM Sans", sans-serif;
`;
